export const dashboardHeaders = {
  brandInfoHeaders: [
    {
      text: 'ブランド名',
      align: 'center',
      sortable: false,
      value: 'name',
      width: ''
    },
    {
      text: '合計',
      align: 'center',
      sortable: false,
      value: 'name',
      width: '12%'
    },
    {
      text: '申込',
      align: 'center',
      sortable: false,
      value: 'name',
      width: '12%'
    },
    {
      text: '相談割当て',
      align: 'center',
      sortable: false,
      value: 'name',
      width: '12%'
    },
    {
      text: '対応中',
      align: 'center',
      sortable: false,
      value: 'name',
      width: '12%'
    },
    {
      text: '後処理',
      align: 'center',
      sortable: false,
      value: 'name',
      width: '12%'
    },
    {
      text: '終了',
      align: 'center',
      sortable: false,
      value: 'name',
      width: '12%'
    }
    // {
    //   text: '관리',
    //   align: 'center',
    //   sortable: false,
    //   value: 'name'
    // }
  ],
  todayAdminApproveHeaders: [
    {
      text: '生成されたブランド',
      align: 'center',
      sortable: false,
      value: 'name'
    },
    {
      text: '自動メッセージの承認申請',
      align: 'center',
      sortable: false,
      value: 'name'
    },
    {
      text: 'モジュールの承認申請',
      align: 'center',
      sortable: false,
      value: 'name'
    }
  ],
  // 20191203 todayApproveHeader 끝
  todaySummaryHeaders: {
    header1: [
      {
        text: 'トークモジュール',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '合計',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '未要請',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '待機中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '相談割当て',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '対応中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '後処理',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '終了',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ],
    header2: [
      {
        text: '全体のマネージャー数',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '平均相談時間',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '平均応対数',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '前日との増加率の対比',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ],
    header3: [
      {
        text: 'ブランド名',
        align: 'center',
        sortable: false,
        value: 'name',
        width: ''
      },
      {
        text: '名前',
        align: 'center',
        sortable: false,
        value: 'name',
        width: '14%'
      },
      {
        text: '現在の状態',
        align: 'center',
        sortable: false,
        value: 'name',
        width: '14%'
      },
      {
        text: '対応中',
        align: 'center',
        sortable: false,
        value: 'name',
        width: '14%'
      },
      {
        text: '後処理',
        align: 'center',
        sortable: false,
        value: 'name',
        width: '14%'
      },
      {
        text: '完了',
        align: 'center',
        sortable: false,
        value: 'name',
        width: '14%'
      }
    ],
    header4: [
      {
        text: 'ブランド名',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '当日の未処理',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '1 ~ 2日',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '3 ~ 6日',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '1週間以上',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '詳細を見る',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ],
    chatbot: [
      {
        text: '合計',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '応対中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '終了',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: 'オペレーター接続要請',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ],
    email: [
      {
        text: '合計',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '未要請',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '待機中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '相談の割当て',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '対応中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '後処理',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '終了',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ],
    webchat: [
      {
        text: '合計',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '未要請',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '待機中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '相談の割当て',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '対応中',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '後処理',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '終了',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ],
    call: [
      {
        text: '合計',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '相談の割当て',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '終了',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '発信',
        align: 'center',
        sortable: false,
        value: 'name'
      },
      {
        text: '発信の接続',
        align: 'center',
        sortable: false,
        value: 'name'
      }
    ]
  }

}
export const managerDashboard = {
  todayBrandIncomingLabels: [
    '0時',
    '1時',
    '2時',
    '3時',
    '4時',
    '5時',
    '6時',
    '7時',
    '8時',
    '9時',
    '10時',
    '11時',
    '12時',
    '13時',
    '14時',
    '15時',
    '16時',
    '17時',
    '18時',
    '19時',
    '20時',
    '21時',
    '22時',
    '23時'
  ]
}

export const timeConsumptionHeaders = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate'
  },
  {
    text: 'オペレーター',
    align: 'center',
    sortable: false,
    value: 'agentName'
  },
  {
    text: '受付',
    align: 'center',
    sortable: false,
    value: 'completedCount'
  },
  {
    text: '対応時間合計',
    align: 'center',
    sortable: false,
    value: 'totalConsultTime'
  },
  {
    text: '平均対応時間',
    align: 'center',
    sortable: false,
    value: 'averageConsultTime'
  },
  {
    text: '後処理時間合計',
    align: 'center',
    sortable: false,
    value: 'totalSummaryWaitingTime'
  },
  {
    text: '平均 後処理時間',
    align: 'center',
    sortable: false,
    value: 'averageSummaryWaitingTime'
  }
]

export const categoryTimeConsumptionHeaders = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate'
  },
  {
    text: '質問カテゴリ',
    align: 'center',
    sortable: false,
    value: 'categoryKey'
  },
  {
    text: '受付',
    align: 'center',
    sortable: false,
    value: 'completedCount'
  },
  {
    text: '対応時間合計',
    align: 'center',
    sortable: false,
    value: 'totalConsultTime'
  },
  {
    text: '平均対応時間',
    align: 'center',
    sortable: false,
    value: 'averageConsultTime'
  },
  {
    text: '後処理時間合計',
    align: 'center',
    sortable: false,
    value: 'totalSummaryWaitingTime'
  },
  {
    text: '平均 後処理時間',
    align: 'center',
    sortable: false,
    value: 'averageSummaryWaitingTime'
  }
]

export const counselTypeTimeConsumptionHeaders = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate'
  },
  {
    text: '分類カテゴリ',
    align: 'center',
    sortable: false,
    value: 'categoryKey'
  },
  {
    text: '受付',
    align: 'center',
    sortable: false,
    value: 'completedCount'
  },
  {
    text: '対応時間合計',
    align: 'center',
    sortable: false,
    value: 'totalConsultTime'
  },
  {
    text: '平均対応時間',
    align: 'center',
    sortable: false,
    value: 'averageConsultTime'
  },
  {
    text: '後処理時間合計',
    align: 'center',
    sortable: false,
    value: 'totalSummaryWaitingTime'
  },
  {
    text: '平均 後処理時間',
    align: 'center',
    sortable: false,
    value: 'averageSummaryWaitingTime'
  }
]

export const categoryIncomingHeaders = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate',
    width: '18%'
  },
  {
    text: '質問カテゴリ',
    align: 'center',
    sortable: false,
    value: 'categoryKey',
    width: '18%'
  },
  {
    text: '合計',
    align: 'center',
    sortable: false,
    value: 'totalCount',
    width: '6%'
  },
  {
    text: '未受付',
    align: 'center',
    sortable: false,
    value: 'searchCount',
    width: '6%'
  },
  {
    text: '申込',
    align: 'center',
    sortable: false,
    value: 'requestCount',
    width: '6%'
  },
  {
    text: '申込率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  },
  {
    text: '申込キャンセル',
    align: 'center',
    sortable: false,
    value: 'exitCount',
    width: '6%'
  },
  {
    text: '受付',
    align: 'center',
    sortable: false,
    value: 'pickCount',
    width: '6%'
  },
  {
    text: '受付率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  }
]

export const categoryIncomingHeadersWithoutCategory = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate',
    width: '18%'
  },
  {
    text: '合計',
    align: 'center',
    sortable: false,
    value: 'totalCount',
    width: '6%'
  },
  {
    text: '未受付',
    align: 'center',
    sortable: false,
    value: 'searchCount',
    width: '6%'
  },
  {
    text: '申込',
    align: 'center',
    sortable: false,
    value: 'requestCount',
    width: '6%'
  },
  {
    text: '申込率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  },
  {
    text: '申込キャンセル',
    align: 'center',
    sortable: false,
    value: 'exitCount',
    width: '6%'
  },
  {
    text: '受付',
    align: 'center',
    sortable: false,
    value: 'pickCount',
    width: '6%'
  },
  {
    text: '受付率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  }
]

export const chatBotIncomingHeaders = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate',
    width: '10%'
  },
  {
    text: 'チャットボット名',
    align: 'center',
    sortable: false,
    value: 'brandName',
    width: '15%'
  },
  {
    text: '合計',
    align: 'center',
    sortable: false,
    value: 'incomingCount',
    width: '8%'
  },
  {
    text: 'カカオ相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestKakaoCount',
    width: '8%'
  },
  {
    text: 'ネイバー相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestNaverCount',
    width: '8%'
  },
  {
    text: 'Webチャット相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestWebchatCount',
    width: '8%'
  },
  {
    text: 'Facebook 相談接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestFacebookCount',
    width: '8%'
  },
  {
    text: 'Facebook相談への接続',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  },
  {
    text: 'オペレーターの受付',
    align: 'center',
    sortable: false,
    value: 'consultingAcceptCount',
    width: '8%'
  },
  {
    text: '申込キャンセル',
    align: 'center',
    sortable: false,
    value: 'consultingGiveupCount',
    width: '8%'
  },
  {
    text: '受付率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  }
]

export const chatBotIncomingHeadersWithoutScenario = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate',
    width: '10%'
  },
  {
    text: '合計',
    align: 'center',
    sortable: false,
    value: 'incomingCount',
    width: '8%'
  },
  {
    text: 'カカオ相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestKakaoCount',
    width: '8%'
  },
  {
    text: 'ネイバー相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestNaverCount',
    width: '8%'
  },
  {
    text: 'Webチャット相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestWebchatCount',
    width: '8%'
  },
  {
    text: 'Facebook相談への接続',
    align: 'center',
    sortable: false,
    value: 'consultingRequestFacebookCount',
    width: '8%'
  },
  {
    text: '申込率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  },
  {
    text: 'オペレーターの受付',
    align: 'center',
    sortable: false,
    value: 'consultingAcceptCount',
    width: '8%'
  },
  {
    text: '申込キャンセル',
    align: 'center',
    sortable: false,
    value: 'consultingGiveupCount',
    width: '8%'
  },
  {
    text: '受付率',
    align: 'center',
    sortable: false,
    value: 'respondRate',
    width: '8%'
  }
]

export const callIncomingHeaders = [
  {
    text: '日時',
    align: 'center',
    sortable: false,
    value: 'regDate',
    width: '10%'
  },
  {
    text: '合計',
    align: 'center',
    sortable: false,
    value: 'ivrIncomingCount',
    width: '6%'
  },
  {
    text: '相談の割当て',
    align: 'center',
    sortable: false,
    value: 'inboundIncomingCount',
    width: '6%'
  },
  {
    text: '終了',
    align: 'center',
    sortable: false,
    value: 'inboundCounselCount',
    width: '6%'
  },
  {
    text: '受付率',
    align: 'center',
    sortable: false,
    value: 'inboundResponseRate',
    width: '4.5%'
  },
  {
    text: '発信',
    align: 'center',
    sortable: false,
    value: 'outboundRequestCount',
    width: '6%'
  },
  {
    text: '発信の接続',
    align: 'center',
    sortable: false,
    value: 'outboundConnectCount',
    width: '6%'
  },
  {
    text: '接続率',
    align: 'center',
    sortable: false,
    value: 'outboundResponseRate',
    width: '4.5%'
  }
]



// WEBPACK FOOTER //
// ./src/charts/data.js